import { render, staticRenderFns } from "./BubbleMenuBar.vue?vue&type=template&id=7c67a0b5"
import script from "./BubbleMenuBar.vue?vue&type=script&lang=js"
export * from "./BubbleMenuBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports